import React, { memo, useCallback, useMemo } from 'react';
import qs from 'qs';
import classnames from 'classnames';
import { Button, Image, Upload, UploadProps } from 'antd';
import { UploadOutlined, PlusOutlined } from '@ant-design/icons';
import { UploadFile } from 'antd/lib/upload/interface';
import { uploadFile } from '@/services/file';
import styles from './index.module.scss';

export type ImgUploadProps = {
  value?: Array<string> | string;
  children?: React.ReactNode;
  onChange?: (fileUrlList: Array<string> | string) => void;
} & UploadProps;

const ImgUpload: React.FC<ImgUploadProps> = ({ value, children, onChange, ...props }) => {
  const uploadButton = useMemo(
    () =>
      props.listType !== 'text' ? (
        <div style={{ color: '#aaa' }}>
          <PlusOutlined />
          <div style={{ marginTop: 8 }}>点击上传</div>
        </div>
      ) : (
        <Button className={styles.uploadBtn} type="default" icon={<UploadOutlined />}>
          点击上传
        </Button>
      ),
    [props.listType]
  );
  const getFileList = useCallback(() => {
    if (!value || !value.length) {
      return [];
    }
    if (Array.isArray(value) && value.length) {
      return value.map(v => {
        const queryString = v.split('?')[1];
        const query = qs.parse(queryString);
        return {
          uid: query.uid || '',
          name: query.name || '',
          url: v,
        } as UploadFile;
      });
    } else {
      const queryString = (value as string).split('?')[1];
      const query = qs.parse(queryString);
      return [
        {
          uid: query.uid || '',
          name: query.name || '',
          url: value,
        } as UploadFile,
      ];
    }
  }, [value]);
  const fileList = useMemo(getFileList, [getFileList]);
  return (
    <>
      {props.listType === 'text' &&
        fileList.map((item, index) => {
          return (
            <div key={index} className={styles.thumbnail}>
              <Image
                width={100}
                height={100}
                src={item.url}
                alt="人员头像"
                preview={false}
                onClick={e => e.stopPropagation()}
              />
              <svg
                className={classnames('icon', styles.removeIcon)}
                aria-hidden="true"
                onClick={e => {
                  e.stopPropagation();
                  const changedFileList = fileList.filter((_, i) => i !== index).map(v => v.url);
                  onChange?.(props.maxCount === 1 ? changedFileList[0] : changedFileList);
                }}
              >
                <use xlinkHref="#icon-clear-copy" />
              </svg>
            </div>
          );
        })}
      <Upload
        fileList={fileList}
        onChange={async ({ fileList }) => {
          for (let i = 0; i < fileList.length; i++) {
            if (fileList[i].url) {
              continue;
            }
            const form = new FormData();
            form.append('file', fileList[i].originFileObj);
            const res = await uploadFile(form);
            const { filename, url } = res.data;
            fileList[i].url = `${url}?name=${filename}`;
          }
          const changedFileList = fileList.map(v => v.url);
          onChange?.(props.maxCount === 1 ? changedFileList[0] || '' : changedFileList);
        }}
        {...props}
      >
        {(!props.maxCount || fileList.length < props.maxCount) && (children || uploadButton)}
      </Upload>
    </>
  );
};

export default memo(ImgUpload);
